import { useMutation, useQueryClient } from '@tanstack/react-query';
import { billingKeys, billingOptions } from '../../constants/billing';
import { ownedParkingKeys } from '../../constants/ownedParkings';
import { bankAccountKeys } from '../../constants/bankAccount';
export function useBillingActions() {
    const queryClient = useQueryClient();
    const getBillings = async () => {
        return await queryClient.fetchQuery(billingOptions.get());
    };
    const invalidateBilling = () => {
        queryClient.invalidateQueries({ queryKey: bankAccountKeys.all });
        queryClient.invalidateQueries({ queryKey: billingKeys.all });
        queryClient.invalidateQueries({ queryKey: ownedParkingKeys.all });
    };
    const createMutation = useMutation({ ...billingOptions.create(), onSuccess: invalidateBilling });
    const updateMutation = useMutation({ ...billingOptions.update(), onSuccess: invalidateBilling });
    const removeMutation = useMutation({ ...billingOptions.remove(), onSuccess: invalidateBilling });
    const selectDefaultMutation = useMutation({
        ...billingOptions.selectDefault(),
        onSuccess: invalidateBilling,
    });
    return {
        getBillings,
        createBilling: createMutation.mutateAsync,
        updateBilling: updateMutation.mutateAsync,
        deleteBilling: removeMutation.mutateAsync,
        selectDefaultBilling: selectDefaultMutation.mutateAsync,
        savingBilling: createMutation.isPending || updateMutation.isPending,
        deletingBilling: removeMutation.isPending,
        selectingDefaultBilling: selectDefaultMutation.isPending,
    };
}
